import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledCalendarSolidIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99561 2.99656L7.99557 7.00182",
			stroke: "#333333",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.002 2.99656L16.0019 7.00182",
			stroke: "#333333",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.74609 7.00122C8.74609 7.41541 8.41028 7.75119 7.99609 7.75122C7.58188 7.75122 7.24609 7.41543 7.24609 7.00122L7.24609 2.99634C7.24621 2.58222 7.58195 2.24634 7.99609 2.24634C8.41023 2.24634 8.74598 2.58223 8.74609 2.99634L8.74609 7.00122Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.752 7.00122C16.7519 7.41541 16.4161 7.75119 16.002 7.75122C15.5877 7.75122 15.2519 7.41543 15.252 7.00122L15.252 2.99634C15.2521 2.58222 15.5878 2.24634 16.002 2.24634C16.4161 2.24634 16.7518 2.58223 16.752 2.99634L16.752 7.00122Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.75 18.4951C20.7499 19.358 20.4598 20.1857 19.9443 20.7959C19.4286 21.4063 18.7284 21.75 17.999 21.75H5.99902C5.26994 21.7498 4.57122 21.4061 4.05566 20.7959C3.54009 20.1856 3.25013 19.3581 3.25 18.4951V11.748H20.75V18.4951ZM6.49609 7.00098L6.50293 7.15527C6.57486 7.86076 7.13635 8.4222 7.8418 8.49414L7.99609 8.50098C8.8243 8.50079 9.49608 7.82934 9.49609 7.00098V4.25H14.502V7.00098L14.5088 7.15527C14.5807 7.86069 15.1423 8.4221 15.8477 8.49414L16.002 8.50098C16.8303 8.50092 17.5019 7.82942 17.502 7.00098V4.25H17.999C18.7284 4.25 19.4286 4.53994 19.9443 5.05566C20.46 5.57138 20.75 6.27169 20.75 7.00098V10.248H3.25V7.00098C3.25 6.27169 3.54002 5.57138 4.05566 5.05566C4.57119 4.54026 5.27006 4.25019 5.99902 4.25H6.49609V7.00098Z",
			fill: "#333333"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledCalendarSolidIcon);
const Memo = memo(ForwardRef);
export default Memo;
